import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation } from "@react-navigation/native";
import type { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { MoreHorizontal } from "lucide-react-native";
import {
  QuestionLayout,
  IconInput,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useDiseaseHistory } from "../../DiseaseHistoryContext";
import type { DiseaseHistoryStackParamList } from "../../DiseaseHistoryNavigator";
import { useFlowProgress } from "../../useFlowProgress";

export function BreastSymptomOtherScreen() {
  const t = useTranslations();
  const { state, updateState, save } = useDiseaseHistory();
  const navigation =
    useNavigation<NativeStackNavigationProp<DiseaseHistoryStackParamList>>();
  const progress = useFlowProgress("BreastSymptomOther");

  const otherCondition = state.breastConditions.find(
    (c) => c.condition === "other",
  );
  const otherText = otherCondition?.other ?? "";

  const handleChange = (text: string) => {
    const updatedConditions = state.breastConditions.map((c) =>
      c.condition === "other" ? { ...c, other: text || null } : c,
    );
    updateState({ breastConditions: updatedConditions });
  };

  const handleSave = async () => {
    await save();
    const currentIdx = state.navigationStack.indexOf("BreastSymptomOther");
    const nextRoute = state.navigationStack[currentIdx + 1];
    if (nextRoute) {
      navigation.navigate(nextRoute);
    }
  };

  return (
    <QuestionLayout
      title={t(
        "med_history.medical.disease_history.breast_symptom_other.title",
      )}
      subtitle={t(
        "med_history.medical.disease_history.breast_symptom_other.subtitle",
      )}
      onBack={() => navigation.goBack()}
      progress={progress}
      onSave={handleSave}
      saveDisabled={false}
      saveLabel={t("med_history.medical.shared.next")}
    >
      <View style={styles.container}>
        <IconInput
          icon={MoreHorizontal}
          label={t(
            "med_history.medical.disease_history.breast_symptom_other.label",
          )}
          placeholder={t(
            "med_history.medical.disease_history.breast_symptom_other.placeholder",
          )}
          value={otherText}
          onChangeText={handleChange}
          multiline
          numberOfLines={4}
        />
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    marginBottom: 40,
  },
});
